import { dayLabel, draftRoundTypes, programToDraft, workoutToSlotDrafts, type Program, type Workout } from "@heraion/shared";

import { useLocale } from "../primitives/useLocale";
import { ModelSaveDialog, type ModelSaveDialogProps } from "./ModelSaveDialog";

type SourceProps = Omit<ModelSaveDialogProps, "source">;

// #354: «Save as model» on the caller's own program, all its days and rounds.
export function SaveAsModelDialog({ program, ...props }: SourceProps & { program: Program }) {
  const lang = useLocale();
  const source = () => {
    const draft = programToDraft(program, props.unit, lang);
    return {
      days: draft.sessions,
      roundTypes: draftRoundTypes(draft),
      sessionsPerWeek: draft.sessionsPerWeek,
      focus: draft.focus,
      description: draft.description,
      locale: draft.editLocale ?? null,
      dayLabel: (d: number) => dayLabel(draft, d),
    };
  };
  return <ModelSaveDialog {...props} source={source} />;
}

// #359: «Save as model» on a logged session: one day, one round, a row per
// exercise from its heaviest set (workoutToSlotDrafts). `defaultName` is the
// session's name, and the day's.
export function SaveSessionAsModelDialog({ workout, ...props }: SourceProps & { workout: Workout }) {
  const lang = useLocale();
  const source = () => {
    const { slots, warmUps, bodyweight } = workoutToSlotDrafts(workout, props.unit, props.catalog ?? undefined);
    return {
      days: [{ name: props.defaultName, slots }],
      roundTypes: ["normal" as const],
      sessionsPerWeek: 1,
      description: "",
      // A session declares no language: the athlete's own is the one they write in.
      locale: lang,
      warmUps,
      bodyweight,
    };
  };
  return <ModelSaveDialog {...props} source={source} />;
}
